import { Box } from '@material-ui/core';
import { SText } from '@setvi/shared/components';
import { TextColor } from '@setvi/shared/enums';
import { Product } from '@setvi/shared/interfaces';

export interface PricingProps {
  value: number;
  label?: string;
}

export const Price = ({ value, label }: PricingProps) => (
  <SText
    title={`${label}: ${
      value >= 0 && value !== null
        ? value.toLocaleString('en-US', {
            currency: 'USD',
            style: 'currency'
          })
        : '-'
    }`}
  />
);
export const Cost = ({ value, label }: PricingProps) => (
  <SText
    title={`${label}: ${
      value > 0
        ? value.toLocaleString('en-US', {
            currency: 'USD',
            style: 'currency'
          })
        : '-'
    }`}
  />
);

export interface CalculatedPricingProps {
  price: Product['price'];
  cost: Product['cost'];
  label: string;
}

export const Profit = ({ price, cost, label }: CalculatedPricingProps) => (
  <Box display="flex">
    <SText
      title={`${label}: ${
        price > cost
          ? (price - cost).toLocaleString('en-US', {
              currency: 'USD',
              style: 'currency'
            })
          : '-'
      }`}
    />
    {price > cost && (
      <SText
        title={`(${(((price - cost) / price) * 100).toFixed(2).toString()}%)`}
        weight="normal"
        fontColor={TextColor.Green}
        style={{ marginLeft: '5px' }}
      />
    )}
  </Box>
);
export const Discount = ({ price, cost, label }: CalculatedPricingProps) => (
  <Box display="flex">
    <SText
      title={`${label}: ${
        price > cost
          ? (price - cost).toLocaleString('en-US', {
              currency: 'USD',
              style: 'currency'
            })
          : '-'
      }`}
    />
    {price > cost && (
      <SText
        title={`(${(((price - cost) / cost) * 100).toFixed(2).toString()}%)`}
        weight="normal"
        fontColor={TextColor.Green}
        style={{ marginLeft: '5px' }}
      />
    )}
  </Box>
);
